module.exports = __webpack_public_path__ + "img/poker-s01.0943a683.svg";